import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SubscriptionModal = 'upgrade' | 'refill' | 'external' | null;

export type SubscriptionState = {
    activeModal: SubscriptionModal;
    modalProps: Record<string, any>;
};

const initialState: SubscriptionState = {
    activeModal: null,
    modalProps: {},
};

const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {
        openUpgradeModal: (state: SubscriptionState, action: PayloadAction<Record<string, any>>) => {
            state.activeModal = 'upgrade';
            state.modalProps = action.payload;
        },
        openExternalModal: (state: SubscriptionState, action: PayloadAction<Record<string, any>>) => {
            state.activeModal = 'external';
            state.modalProps = action.payload;
        },
        openRefillModal: (state: SubscriptionState, action: PayloadAction<Record<string, any>>) => {
            state.activeModal = 'refill';
            state.modalProps = action.payload;
        },
        closeSubscriptionModal: (state: SubscriptionState) => {
            state.activeModal = null;
            state.modalProps = {};
        },
    },
});

export const { openExternalModal, openUpgradeModal, openRefillModal, closeSubscriptionModal } =
    subscriptionSlice.actions;

export default subscriptionSlice;
